import { FormErrors } from "redux-form";

import {
  PhoneInputFormValues,
  AugmentedPhoneInputFormProps,
} from "./components/PhoneInputForm";

// https://github.com/datnq/Vietnamese-mobile-carrier + support for leading +84
const PHONE_PATTERN = /^(\+84|0)(1[2689]|9)[0-9]{8}$/;

// Select options not checked for changes; not important on client, leave to server
function validate(
  formValues: PhoneInputFormValues,
  props: AugmentedPhoneInputFormProps,
) {
  const errors: FormErrors<PhoneInputFormValues> = {};

  const genRequiredMsg = () => "Cần thiết";

  if (!formValues.phone) {
    errors.phone = genRequiredMsg();
  } else if (!PHONE_PATTERN.test(formValues.phone.replace(/\s/g, ""))) {
    errors.phone = "SĐT không hợp lệ";
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/routes/Step1/phone-input-form-validation.ts